import {QueryFunction, useQuery} from '@tanstack/react-query'
import {AxiosResponse} from 'axios'

import {DocumentModel, DocumentsTableFilter} from '../Documents.types'
import {api} from "../../../App.global";


type FetchDocumentsRequestProps = DocumentsTableFilter & {
  customerId: string
  skip: number
  limit: number
}

type DocumentsQueryKey = [string, {filter: DocumentsTableFilter; customerId: string}]

const getDocuments: QueryFunction<DocumentModel[], DocumentsQueryKey> = async ({
  queryKey
}): Promise<DocumentModel[]> => {
  const [_, {filter, customerId}] = queryKey

  const params: FetchDocumentsRequestProps = {
    ...filter,
    skip: (filter.page - 1) * filter.rowsPerPage,
    limit: filter.rowsPerPage,
    customerId: customerId
  }

  const response: AxiosResponse<DocumentModel[]> = await api.get(`/documents/sharepoint`, {params})

  return response.data
}

type UseDocumentsProps = {
  filter: DocumentsTableFilter
  customerId?: string
}

export const useDocuments = ({filter, customerId}: UseDocumentsProps) => {
  return useQuery(['documents', {filter, customerId: customerId || ''}], getDocuments)
}
